import React from 'react';

const ChatInput = ({ 
  inputMessage, 
  setInputMessage, 
  sendMessage, 
  isTyping, 
  chatEnded,
  sendingLead 
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  if (chatEnded) {
    return (
      <div className="chat-input">
        <div className="text-center py-3">
          <i className="fas fa-check-circle text-success mb-2" style={{fontSize: '2rem'}}></i>
          <p className="mb-0 text-muted">
            <strong>Chat beendet</strong><br />
            Deine Anfrage wurde erfolgreich übermittelt!
          </p>
        </div>
      </div>
    );
  }

    if (sendingLead) {
    return (
      <div className="chat-input">
        <div className="text-center py-3">
          <div className="spinner-border text-primary mb-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mb-0 text-muted">
            <strong>Sende Anfrage...</strong><br />
            Deine Daten werden an Ivo übermittelt.
          </p>
        </div>
      </div>
    );
  }
  

  return (
    <div className="chat-input">
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="Schreibe Deine Nachricht..."
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={isTyping}
        />
        <button
          className="btn btn-primary"
          type="button"
          onClick={sendMessage}
          disabled={isTyping || !inputMessage.trim()}
        >
          {isTyping ? (
            <i className="fas fa-spinner fa-spin"></i>
          ) : (
            <i className="fas fa-paper-plane"></i>
          )}
        </button>
      </div>
      <small className="text-muted mt-1 d-block">
        <i className="fas fa-lock me-1"></i>
        Deine Daten werden sicher verarbeitet
      </small>
    </div>
  );
};

export default ChatInput;
